/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:22
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      // console.log("-=> utils_controller connected");
    }

    initialize() {
    }

    set_prospect() {
      // console.log("-=> utils_controller set_prospect / " + event.currentTarget.value);
      document.cookie="current_prospect_id=" + event.currentTarget.value
      location.reload();
    }

    set_resume() {
      // console.log("-=> utils_controller set_prospect / " + event.currentTarget.value);
      document.cookie="current_resume_id=" + event.currentTarget.value
      location.reload();
    }

    show_pagehelp_modal() {
      $('#pagehelp_modal').modal({offset: 0}).modal('show');
    }

    new_resume_button() {
      $.post( '/resumes', { 'resume[name]' : $("#new_resume_name").val() });
    }

  };

// console.log("-=> utils_controller loaded");

